export default function decimalToBinary(decimal: number, padStartTo?: number) {
  const binary = (decimal >>> 0).toString(2);
  if (padStartTo) {
    return binary.padStart(padStartTo, "0");
  } else {
    return binary;
  }
}
